module.exports = __webpack_public_path__ + "static/media/1-3.a37bf52f.mp3";